import { StaticToggleService } from 'util/services/staticToggleService';
import { FolderDataStore } from 'sharebase-app/dataStores/folderDataStore';
import { EnvironmentService } from 'phoenix/services/environmentService';
import {
	ShareBaseItem, 
	ShareBaseFolder, 
	ShareBaseDocument, 
	UploadException
} from 'phoenix/domain';
import angular = require('angular');

const template = require('./virtualTileContainer.template');
require('./virtualTileContainer.styles');

/**
* @ngdoc directive
* @name phoenix.directive:pxVirtualTileContainer
* @module phoenix
* @restrict E
* @description
*
* `pxVirtualTileContainer` is a virtualizer of tile items that groups items into rows of a fixed height to work with md-virtual-repeat-container
*
* @param {object} virtualItems The item to be bound to.
*
* @usage
*
* <px-virtual-tile-container virtual-items="appCtrl.folders"></px-virtual-tile-container>
*/
export function VirtualizeTileViewDirective(
	$timeout:ng.ITimeoutService, 
	$window:ng.IWindowService, 
	$mdUtil, 
	$mdMedia, 
	pxGroupItemsService
) {
	return {
		restrict: 'E',
		controller: VirtualizeTileContainerController,
		controllerAs: 'VirtualTileCtrl',
		bindToController: true,
		scope: {
			showThumbnails: '=',
			rawitems: '=virtualItems',
			groupedrawitems: '=virtualGroupedItems',
			click: '&?virtualClick',
			select: '&?virtualSelect',
			rightClick: '&?virtualRightClick',
			selectedItems: '=virtualSelectedItems',
			inProgressItems: '=virtualInProgressItems',
			disableDrag: '=?',
			onUpload: '<?',
			onUploadError: '<?'
		},
		template,
		link: function (scope, element, attrs) {
			var vm = scope.VirtualTileCtrl;
			vm.calcVirtualGroups = $mdUtil.debounce(calcVirtualGroups, 250);
			vm.tilePerLine = null;
			vm.style = {};
			var container = null;
			function calcVirtualGroups() {
				var TILE_WIDTH = 170;
				var newTilePerLine = null;
				var containerWidth = null;
				if(vm.rawitems){
					var outerContainer = $mdUtil.getClosest(element, 'md-virtual-repeat-container');//md-virtual-repeat-offsetter
					container = outerContainer.querySelector('.md-virtual-repeat-offsetter');
				}
				else{						
					container = element.parent()[0];
				}
				if (container) {
					containerWidth = container.clientWidth;
					if(containerWidth > 600){
						containerWidth -= 16; //8px margin on each side
						newTilePerLine = Math.floor(containerWidth / TILE_WIDTH);
					}
					else if(containerWidth < 600 && containerWidth > 475){							
						containerWidth -= 8; //4px margin on each side
						newTilePerLine = 3;
					}
					else{													
						containerWidth -= 8; //4px margin on each side
						newTilePerLine = 2;
					}

					if (newTilePerLine !== vm.tilePerLine) {
						vm.tilePerLine = newTilePerLine;
						virtualizeItems();
					}
				}
			}

			function virtualizeItems() {
				if (vm.rawitems || vm.groupedrawitems) {
					$timeout(function(){
						//used to set the fixed width to minimize resizing of cards while resizing
						var margin = $mdMedia('sm') || $mdMedia('xs')  ? 8 : 16;							
						var innerWidth = container.clientWidth;					
						vm.style.width = (innerWidth - margin) + 'px';
						//get row items
						if(vm.rawitems){
							var rawItems = vm.rawitems;
							if(Array.isArray(vm.selectedItems)){
								vm.selectedItems.forEach(function(itemSelected){
									var idTarget = itemSelected.DocumentId ? 'DocumentId' : (itemSelected.FolderId ? 'FolderId' : 'LibraryId');
									rawItems.map(function(item){ 
										if(item[idTarget]){
											if(item[idTarget] === itemSelected[idTarget]){
												item.selected = true;
											}
										}

										return item;
									});
								});	
							}

							if (Array.isArray(vm.inProgressItems)) {
								vm.inProgressItems.forEach(function(inProgressItem) {
									var idTarget = inProgressItem.DocumentId ? 'DocumentId' : (inProgressItem.FolderId ? 'FolderId' : 'LibraryId');
									rawItems.map(function(item) {
										if (item[idTarget] && item[idTarget] === inProgressItem[idTarget]) {
											item.inProgress = true;
										}
										return item;
									});
								});
							}

							vm.rowItems = pxGroupItemsService.groupItems(rawItems, vm.tilePerLine);	
						}
						else if(vm.groupedrawitems){
							vm.rowItems = [];
							angular.forEach(vm.groupedrawitems, function(group){
								//only show groups with items in them
								if(group.items.length > 0){
									//add a line for header
									vm.rowItems.push({isHeader: true, label:group.label});
									//add a line for items
									var rowItems = pxGroupItemsService.groupItems(group.items, vm.tilePerLine);	
									vm.rowItems = vm.rowItems.concat(rowItems);								
								}
							});
						}
						$timeout(function(){
							scope.$emit('$md-resize');
						},100);
					},0);
				}
			}

			function itemsChanged(newVal){
				if (newVal === null) { return; }
				vm.tilePerLine = null;
				vm.calcVirtualGroups();
			}
			
			//new items in collection
			scope.$watchCollection('VirtualTileCtrl.rawitems', function (newVal, oldVal) {		
				itemsChanged(newVal);
			});
			scope.$watchCollection('VirtualTileCtrl.groupedrawitems', function (newVal, oldVal) {
				itemsChanged(newVal);
			});

			//element's width has changed
			scope.$watch(function () { return element[0].clientWidth; },
				function (newVal, oldVal) {	
					vm.calcVirtualGroups();
				}
			);		

			scope.$watchCollection('VirtualTileCtrl.selectedItems', function(newVal, oldVal){
				if(!newVal && !oldVal || !Array.isArray(newVal) || !vm.rawitems){ return;}
				
				if(newVal.length === 0 && oldVal.length > 0){
					//clear selection
					vm.selectAll = false;
					vm.rowItems.forEach(function(row){
						row.map(function(item){
							item.selected = false;
							return item;
						});
					});
				}

				if(newVal.length === vm.rawitems.length){
					//disable transitions
					vm.selectAll = true;
					//select all
					vm.rowItems.forEach(function(row){
						row.map(function(item){
							item.selected = true;
							return item;
						});
					});
				}

			});	

			scope.$watchCollection('VirtualTileCtrl.inProgressItems', function(newVal, oldVal) {
				if (!newVal && !oldVal || !Array.isArray(newVal) || !vm.rawItems) {
					return;
				}

				if (newVal.length === 0 && oldVal.length > 0) {
					// clear selection;
					vm.rowItems.forEach(function(row) {
						row.forEach(function(item) {
							item.inProgress = false;
						});
					});
				}

			});

			//window size events
			$window.addEventListener('resize', vm.calcVirtualGroups);
			$window.addEventListener('orientationchange', vm.calcVirtualGroups);

			scope.$on('$destroy', function () {
				$window.removeEventListener('resize', vm.calcVirtualGroups);
				$window.removeEventListener('orientationchange', vm.calcVirtualGroups);
			});
		}
	};
}

VirtualizeTileViewDirective.$inject = [
	'$timeout',
	'$window',
	'$mdUtil',
	'$mdMedia',
	'pxGroupItemsService'
];

export type SelectableItem = (ShareBaseDocument | ShareBaseFolder) & {
	inProgress:boolean;
	selected:boolean;
}

interface SelectPayload {
	item:ShareBaseItem;
	event?:ng.IAngularEvent;
}

class VirtualizeTileContainerController {	
	private disableDrag:boolean;

	public useDataUri = this.staticToggleService.isEnabled('data-uri-images');
	public click:(payload:SelectPayload) => void;
	public rightClick:(payload: {item: SelectPayload}) => void;
	public select:(payload:SelectPayload) => void;

	public onUpload:(exception:UploadException) => void = angular.isDefined(this.onUpload) ?
		this.onUpload : 
		angular.noop;

	public onUploadError:(exception:UploadException) => void = angular.isDefined(this.onUploadError) ?
		this.onUploadError : 
		angular.noop;

	public readonly dragEnabled = angular.isDefined(this.disableDrag) ? 
		!this.disableDrag && !this.pxEnvironmentService.touchEnabled :
		!this.pxEnvironmentService.touchEnabled;		

	public static $inject = [
		'staticToggleService',
		'pxEnvironmentService',		
		'sbaFolderDataStore'
	];

	constructor(
		private staticToggleService:StaticToggleService,
		public pxEnvironmentService:EnvironmentService,		
		public sbaFolderDataStore:FolderDataStore
	) {}

	public itemClick($event:ng.IAngularEvent, item:SelectableItem) {
		if (item.inProgress || !this.click) {
			return;
		}

		this.click({ 
			item 
		});
	}

	public itemRightClick($event:ng.IAngularEvent, item:ShareBaseItem) {
		if(!this.rightClick){
			return;
		}

		let payload = {
			item,
			event: $event
		};

		this.rightClick({item: payload });
	};

	public itemSelect($event:ng.IAngularEvent, item:ShareBaseItem) {
		if(!this.select){
			return;
		}

		this.select({
			item
		});
	}	

	public toggleSelected($event:ng.IAngularEvent, item:SelectableItem) {
		item.selected = !item.selected;
		if(!this.itemSelect){
			return;
		}

		this.itemSelect($event, item);
	}

	public itemSelected($event:ng.IAngularEvent, item:SelectableItem) {
		// Long click selection is only for mobile browsers
		if (this.pxEnvironmentService.touchEnabled){
			item.selected = true;	
			this.itemSelect($event, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/components/virtualTileContainer/virtualTileContainer.ts